export const environment = {
    production: false,
    appcode: 'CMS',
    serviceBaseUrl: 'https://inclientmaster-uat.ey.net/ClientMasterApi/api/',
    tokenPath: 'https://inclientmaster-uat.ey.net/ClientMasterApi/api/Token',
    logPageAnalytics: 'N',
    isAzureInsights: true,
    pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
    logApplicationInsights : 'Y',
    instrumentationKey : '306905d2-b24a-4274-bf34-a65c81c66ca3',
    msalConfig: {
        authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
        tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
        clientId: "1795007c-d7f6-40e3-992c-38a5e007c432",
        redirectUri: "https://inclientmaster-uat.ey.net",
    },
};
